import { render, staticRenderFns } from "./LeyesIcon.vue?vue&type=template&id=465d7bbc&scoped=true&"
var script = {}
import style0 from "./LeyesIcon.vue?vue&type=style&index=0&id=465d7bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d7bbc",
  null
  
)

export default component.exports